namespace nscs.screen {

    export class MainMenuScreen extends BaseScreen {

        bg:Phaser.GameObjects.Container;
        chick_mc:Phaser.GameObjects.Sprite;
        enterCodeContainer:Phaser.GameObjects.Container;
        buttons:Phaser.GameObjects.Container[];
        code_txt:nscs.input.InputTextField;

        constructor(scene:Phaser.Scene) {
            super(scene);

            this.bg = new Phaser.GameObjects.Container(this.scene, 0, -200, [
                new Phaser.GameObjects.Image(this.scene, 0, 0, 'bg-atlas', 'bg1_bg0000').setOrigin(0, 0),
                new Phaser.GameObjects.Image(this.scene, 728, 0, 'bg-atlas', 'bg1_bg0000').setOrigin(0, 0),
            ]);
            this.add(this.bg);
            this.bg.x = -730;
            this.scene.tweens.add({
                targets: this.bg,
                x: 0,
                duration: 40000,
                ease: Phaser.Math.Easing.Linear,
                repeat: -1
            });

            this.add(new Phaser.GameObjects.Image(this.scene, -200, 240, 'ui-atlas', 'menu_bg_grass'+'0000').setOrigin(0, 0));
            this.add(new Phaser.GameObjects.Image(this.scene, 57, 10, 'ui-atlas', 'bg_mc'+'0000').setOrigin(0, 0));
            this.add(new Phaser.GameObjects.Image(this.scene, -17, -15, 'ui-atlas', 'scs_logo'+'0000').setOrigin(0, 0));
            this.add(new Phaser.GameObjects.Image(this.scene, 260, 140, 'ui-atlas', 'ANI_Chickette_wholeMC'+'0000').setOrigin(0, 0));
            this.add(new Phaser.GameObjects.Image(this.scene, 350, 172, 'ui-atlas', 'ANI_Nugget_wholeMC'+'0000').setOrigin(0, 0));

            let scs_logo_blink = this.scene.add.sprite(275, 90, 'ui-atlas');
            scs_logo_blink.setScale(2);
            let scs_logo_blink_anim:string = 'scs_logo_blink_anim';
            if (!this.scene.anims.exists(scs_logo_blink_anim)) {
                this.scene.anims.create({
                    key: scs_logo_blink_anim,
                    frames: this.scene.anims.generateFrameNames('ui-atlas', {
                        start: 0, end: 327, zeroPad: 4,
                        prefix: 'scs_logo_blink', suffix: ''
                    }),
                    frameRate: 60,
                    repeat: -1
                });
            }
            scs_logo_blink.play(scs_logo_blink_anim);
            this.add(scs_logo_blink);

            this.buttons = [];
            let btnStr:string[] = ['NewGameBtn', 'EnterCodeBtn'/*, 'HighScoresBtn'*/];
            let i:number = 0;
            let btnsY:number = 195+16;
            for (let str of btnStr) {
                let btn:Phaser.GameObjects.Container = new Phaser.GameObjects.Container(this.scene, 145, btnsY + i * 33);
                this.buttons.push(btn);
                let label:Phaser.GameObjects.Text = this.scene.add.text(-50, -10, "", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 16,
                    "color": "#000000",
                    "align": 'left'
                });
                btn.add(label);
                nscs.gameplay.Gameplay.setText(label, str);
                this.add(btn);
                btn.setSize(130, 37);
                btn.setInteractive({cursor: 'pointer'});
                btn[str==btnStr[0]?'once':'on']('pointerup', () => {
                    if (str == 'NewGameBtn') {
                        nscs.scene.MainScene.instance.resetGameplay();
                        nscs.scene.MainScene.instance.switchScreen(new nscs.screen.InstructionScreen(scene));
                        nscs.sound.SoundManager.getInstance().playSound('winnerSND');

                        sendEvent(petaGA_GameCategory_Game, 'New Game', 'New Super Chick Sisters - New Game');
                    } else if (str == 'EnterCodeBtn') {
                        this.setPamCodeEnterVisible(true);
                    } else if (str == 'HighScoresBtn') {
                        nscs.scene.MainScene.instance.switchScreen(new nscs.screen.HigscoreScreen(this.scene));
                        nscs.sound.SoundManager.getInstance().playSound('winnerSND');

                        sendEvent(petaGA_GameCategory_Game, 'Click', 'New Super Chick Sisters - High Scores');
                    }
                });
                btn.on('pointerover', () => {
                    this.scene.tweens.add({
                        targets: this.chick_mc,
                        y: btn.y,
                        duration: 650,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    nscs.sound.SoundManager.getInstance().playSound('coinSND', 0.5);
                });
                i++;
            }

            this.chick_mc = this.chick_mc = nscs.scene.MainScene.instance.factory.createConstructedObject("tinyChickMC") as Phaser.GameObjects.Sprite;
            this.chick_mc.setOrigin(0.5, 0.5);
            this.chick_mc.setPosition(70, btnsY);
            this.add(this.chick_mc);

            this.add(MainMenuScreen.createEye(290, 205, this.scene));
            this.add(MainMenuScreen.createEye(320, 205, this.scene));
            this.add(MainMenuScreen.createEye(370, 224, this.scene));
            this.add(MainMenuScreen.createEye(395, 227, this.scene));

            this.enterCodeContainer = new Phaser.GameObjects.Container(this.scene, 150, 235);
            this.add(this.enterCodeContainer);
            this.enterCodeContainer.visible = false;
            let e = new Phaser.GameObjects.Image(this.scene, 0, 0, 'ui-atlas', 'enterCode_bg'+'0000');
            this.enterCodeContainer.add(e);
            e.setInteractive();
            let enterCode_btn_cancel = new Phaser.GameObjects.Image(this.scene, -50, 33, 'ui-atlas', 'enterCode_btn'+'0000');
            this.enterCodeContainer.add(enterCode_btn_cancel);
            enterCode_btn_cancel.alpha = 0.01;
            let cancel_label:Phaser.GameObjects.Text = this.scene.add.text(enterCode_btn_cancel.x, enterCode_btn_cancel.y, "", {
                "fontFamily": "Helvetica Rounded LT Black",
                "fontSize": 15,
                "color": "#333333",
                "align": 'left'
            });
            cancel_label.setOrigin(0.5, 0.5);
            this.enterCodeContainer.add(cancel_label);
            nscs.gameplay.Gameplay.setText(cancel_label, 'CancelBtn');
            let enterCode_btn_ok = new Phaser.GameObjects.Image(this.scene, 65, 33, 'ui-atlas', 'enterCode_btn'+'0000');
            this.enterCodeContainer.add(enterCode_btn_ok);
            enterCode_btn_ok.alpha = 0.01;
            let ok_label:Phaser.GameObjects.Text = this.scene.add.text(enterCode_btn_ok.x, enterCode_btn_ok.y, "", {
                "fontFamily": "Helvetica Rounded LT Black",
                "fontSize": 15,
                "color": "#333333",
                "align": 'left'
            });
            ok_label.setOrigin(0.5, 0.5);
            this.enterCodeContainer.add(ok_label);
            nscs.gameplay.Gameplay.setText(ok_label, 'OKBtn');
            let pam_label:Phaser.GameObjects.Text = this.scene.add.text(0, -40, "", {
                "fontFamily": "Helvetica Rounded LT Black",
                "fontSize": 13,
                "color": "#333333",
                "align": 'center'
            });
            if (nscs.gameplay.Gameplay.currentLanguage == "ES" || nscs.gameplay.Gameplay.currentLanguage == "SK") {
                pam_label.y = -49;
            }
            pam_label.setOrigin(0.5,0);
            this.enterCodeContainer.add(pam_label);
            pam_label.setWordWrapWidth(200);
            nscs.gameplay.Gameplay.setText(pam_label, 'EnterCodePrompt');
            let enterCode_txtinputbg = new Phaser.GameObjects.Image(this.scene, 0, 8, 'ui-atlas', 'enterCode_txtinputbg'+'0000');
            this.enterCodeContainer.add(enterCode_txtinputbg);

            enterCode_btn_cancel.setInteractive({cursor: 'pointer'});
            enterCode_btn_cancel.on('pointerup', this.onPamCancel);
            enterCode_btn_cancel.on('pointerover', () => {
                nscs.sound.SoundManager.getInstance().playSound('whistleSND');
            });
            enterCode_btn_ok.setInteractive({cursor: 'pointer'});
            enterCode_btn_ok.on('pointerup', this.onPamOK);
            enterCode_btn_ok.on('pointerover', () => {
                nscs.sound.SoundManager.getInstance().playSound('whistleSND');
            });

            this.code_txt = new nscs.input.InputTextField(this.scene);
            this.code_txt.setPosition(-80, enterCode_txtinputbg.y);
            this.enterCodeContainer.add(this.code_txt);
        }

        private onPamCancel:()=>void = ()=>{
            this.setPamCodeEnterVisible(false);
            nscs.sound.SoundManager.getInstance().playSound('winnerSND');
        };
        private onPamOK:()=>void = ()=>{
            let code:string = nscs.util.Functions.trim(this.code_txt.getText().toLowerCase());

            this.setPamCodeEnterVisible(false);

            let nextWorldNo:number = -1;
            switch(code) {
                // jump to level 1:
                case 'test1':
                    nextWorldNo = 1;
                    break;
                // jump to level 2:
                case 'test2':
                    nextWorldNo = 2;
                    break;
                // jump to level 2-1:
                case 'test21':
                    nextWorldNo = 2.1;
                    break;
                // jump to level 2-2:
                case 'test22':
                    nextWorldNo = 2.2;
                    break;
                // jump to level 3:
                case 'test3':
                    nextWorldNo = 3;
                    break;
                // jump to level 4:
                case 'test4':
                    nextWorldNo = 4;
                    break;
                // jump to level 4:
                case 'test41':
                    nextWorldNo = 4.1;
                    break;
                // jump to level 2:
                case 'test5':
                    nextWorldNo = 5;
                    break;
                case 'test51':
                    nextWorldNo = 5.1;
                    break;

                // unlock pam:
                case 'pamvsmccruelty':
                    nscs.gameplay.Gameplay.isPamLocked = false;
                    nscs.scene.MainScene.instance.playAsPam();

                    nscs.sound.SoundManager.getInstance().playSound('winnerSND');

                    sendEvent(petaGA_GameCategory_Game, 'Enter Code', 'New Super Chick Sisters - Enter Code PamVsMcCruelty');
                    return;
            }

            if (nextWorldNo != -1) {
                nscs.scene.MainScene.instance.resetGameplay();
                nscs.scene.MainScene.instance.setWorldsNumber(Math.floor(nextWorldNo), String(nextWorldNo));
                nscs.scene.MainScene.instance.switchScreen(new nscs.screen.KidFriendlyScreen(this.scene));

                nscs.sound.SoundManager.getInstance().playSound('winnerSND');
            }
        };
        public setPamCodeEnterVisible(visible:boolean):void {
            this.enterCodeContainer.visible = visible;
            for (let b of this.buttons) b.visible = !visible;
            this.chick_mc.visible = !visible;
            if (visible) {
                this.code_txt.initializeInput();
            } else {
                this.code_txt.destroyInput();
            }
            this.code_txt.setText('');
        }

        public static createEye(x, y, scene, delay = 0):Phaser.GameObjects.Sprite {
            let blinking_eye = scene.add.sprite(x, y, 'ui-atlas', 'blinking_eye0000');
            let blinking_eye_anim:string = 'blinking_eye_anim';
            if (!scene.anims.exists(blinking_eye_anim)) {
                scene.anims.create({
                    key: blinking_eye_anim,
                    frames: scene.anims.generateFrameNames('ui-atlas', {
                        start: 0, end: 260, zeroPad: 4,
                        prefix: 'blinking_eye', suffix: ''
                    }),
                    frameRate: 60,
                    repeat: -1
                });
            }
            nscs.util.Functions.delayedCall(delay, ()=>{
                if (!blinking_eye.parentContainer || blinking_eye.parentContainer.parentContainer) return;
                blinking_eye.play(blinking_eye_anim);
            });

            return blinking_eye;
        }

        public updateScreen(): void {
            super.updateScreen();

            if (nscs.scene.MainScene.instance.inputController.escPressedDownAndReleased()) {
                if (this.enterCodeContainer.visible) {
                    this.setPamCodeEnterVisible(false);
                } else {
                    nscs.scene.MainScene.instance.switchScreen(new screen.SelectLanguageScreen(this.scene));
                }
                nscs.scene.MainScene.instance.inputController.escPressUsed();
            } else if (nscs.scene.MainScene.instance.inputController.enterPressedDownAndReleased() && this.enterCodeContainer.visible) {
                nscs.scene.MainScene.instance.inputController.enterPressUsed();
                requestAnimationFrame(this.onPamOK);
            }
        }
    }
}